import { useState } from "react";
import { IoIosClose } from "react-icons/io";
import { updateCategoriesSectionData } from "../../../api/webData.api";

const CategoriesEditForm = ({
  setOpenEditCategoriesForm,
  webData,
  setWebData,
  setHideContent,
}) => {
  const [loading, setLoading] = useState(false);
  const [formDataState, setFormDataState] = useState({});

  const sections = [
    {
      title: "Categorías Principales (Fila Superior)",
      items: [
        { key: "residential", label: "Categoría 1 (Izquierda)" },
        { key: "patrimonial", label: "Categoría 2 (Centro)" },
        { key: "others", label: "Categoría 3 (Derecha)" },
      ],
    },
    {
      title: "Ubicaciones Destacadas (Fila Inferior)",
      items: [
        { key: "location1", label: "Ubicación 1" },
        { key: "location2", label: "Ubicación 2" },
        { key: "location3", label: "Ubicación 3" },
        { key: "location4", label: "Ubicación 4" },
      ],
    },
  ];

  const handleFileChange = (e, key) => {
    const file = e.target.files[0];
    if (file) {
      setFormDataState((prev) => ({
        ...prev,
        [key]: { ...prev[key], file },
      }));
    }
  };

  const handleTitleChange = (e, key) => {
    const text = e.target.value;
    setFormDataState((prev) => ({
      ...prev,
      [key]: { ...prev[key], title: text },
    }));
  };

  const handleSubtitleChange = (e, key) => {
    const text = e.target.value;
    setFormDataState((prev) => ({
      ...prev,
      [key]: { ...prev[key], subtitle: text },
    }));
  };

  const SubmitForm = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const keysToUpdate = Object.keys(formDataState);

      if (keysToUpdate.length === 0) {
        setOpenEditCategoriesForm(false);
        setHideContent(false);
        return;
      }

      const promises = keysToUpdate.map(async (key) => {
        const data = formDataState[key];
        const formData = new FormData();

        formData.append("key", key);
        if (data.file) formData.append("image", data.file);
        if (data.title) formData.append("title", data.title);
        if (data.subtitle) formData.append("subtitle", data.subtitle);

        return updateCategoriesSectionData(formData, webData._id);
      });

      await Promise.all(promises);
      window.location.reload();
    } catch (error) {
      console.error("Error al guardar categorías:", error);
      alert(
        "Hubo un error al guardar los cambios. Por favor revisa que la imagen no sea demasiado pesada.",
      );
    } finally {
      setLoading(false);
      setOpenEditCategoriesForm(false);
      setHideContent(false);
    }
  };

  const getImageSrc = (imgUrl) => {
    if (!imgUrl) return "/Logo_animated.svg";
    if (imgUrl.startsWith("/") || imgUrl.startsWith("data:")) return imgUrl;
    if (imgUrl.startsWith("http")) return imgUrl;
    return `https://${imgUrl}`;
  };

  return (
    <form
      onSubmit={SubmitForm}
      style={{
        width: "95%",
        maxWidth: "1200px",
        margin: "40px auto",
        backgroundColor: "#ffffff",
        borderRadius: "12px",
        boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
        display: "flex",
        flexDirection: "column",
        fontFamily: "inherit",
        overflow: "hidden", // Para que los bordes redondeados contengan el header y footer
      }}
    >
      {/* HEADER DEL MODAL */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "20px 30px",
          borderBottom: "1px solid #e9ecef",
          backgroundColor: "#ffffff",
        }}
      >
        <h1
          style={{
            margin: 0,
            fontSize: "1.5rem",
            color: "#343a40",
            fontWeight: "600",
          }}
        >
          Editar Categorías y Ubicaciones
        </h1>
        <IoIosClose
          style={{ fontSize: "32px", cursor: "pointer", color: "#6c757d" }}
          onClick={() => {
            setOpenEditCategoriesForm(false);
            setHideContent(false);
          }}
        />
      </div>

      {/* CONTENEDOR CON SCROLL */}
      <div
        style={{
          overflowY: "auto",
          maxHeight: "70vh",
          padding: "30px",
          backgroundColor: "#f8f9fa", // Fondo ligerito para que resalten las tarjetas blancas
        }}
      >
        {sections.map((section, idx) => (
          <div
            key={idx}
            style={{
              marginBottom: "3rem",
              background: "#ffffff",
              padding: "30px",
              borderRadius: "12px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
              border: "1px solid #e9ecef",
            }}
          >
            <h3
              style={{
                borderBottom: "2px solid #e9ecef",
                paddingBottom: "15px",
                marginBottom: "30px",
                color: "#212529",
                textAlign: "center",
                fontSize: "1.3rem",
                fontWeight: "bold",
              }}
            >
              {section.title}
            </h3>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: `repeat(${section.items.length}, minmax(200px, 1fr))`,
                gap: "25px",
                alignItems: "start",
                overflowX: "auto",
              }}
            >
              {section.items.map((item) => {
                const currentData =
                  webData?.categoriesSection?.[item.key] || {};

                return (
                  <div
                    key={item.key}
                    style={{
                      background: "#ffffff",
                      padding: "20px",
                      borderRadius: "8px",
                      border: "1px solid #dee2e6",
                      display: "flex",
                      flexDirection: "column",
                      gap: "15px",
                      minWidth: "220px",
                    }}
                  >
                    <h4
                      style={{
                        fontSize: "13px",
                        textTransform: "uppercase",
                        color: "#6c757d",
                        margin: "0",
                        fontWeight: "bold",
                        textAlign: "center",
                        borderBottom: "1px solid #f8f9fa",
                        paddingBottom: "10px",
                      }}
                    >
                      {item.label}
                    </h4>

                    {/* INPUT: TÍTULO */}
                    <div>
                      <label
                        style={{
                          fontSize: "12px",
                          fontWeight: "bold",
                          display: "block",
                          marginBottom: "5px",
                          textAlign: "center",
                          color: "#495057",
                        }}
                      >
                        Título:
                      </label>
                      <input
                        type="text"
                        defaultValue={currentData.title || ""}
                        onChange={(e) => handleTitleChange(e, item.key)}
                        placeholder="Ej: Residencial"
                        style={{
                          width: "100%",
                          padding: "10px",
                          border: "1px solid #ced4da",
                          borderRadius: "6px",
                          boxSizing: "border-box",
                          outline: "none",
                        }}
                      />
                    </div>

                    {/* INPUT: SUBTÍTULO */}
                    <div>
                      <label
                        style={{
                          fontSize: "12px",
                          fontWeight: "bold",
                          display: "block",
                          marginBottom: "5px",
                          textAlign: "center",
                          color: "#495057",
                        }}
                      >
                        Subtítulo:
                      </label>
                      <input
                        type="text"
                        defaultValue={currentData.subtitle || ""}
                        onChange={(e) => handleSubtitleChange(e, item.key)}
                        placeholder="Ej: Descubre las viviendas..."
                        style={{
                          width: "100%",
                          padding: "10px",
                          border: "1px solid #ced4da",
                          borderRadius: "6px",
                          boxSizing: "border-box",
                          outline: "none",
                        }}
                      />
                    </div>

                    {/* PREVIEW E INPUT: IMAGEN */}
                    <div>
                      <label
                        style={{
                          fontSize: "12px",
                          fontWeight: "bold",
                          display: "block",
                          marginBottom: "5px",
                          textAlign: "center",
                          color: "#495057",
                        }}
                      >
                        Imagen:
                      </label>

                      <div
                        style={{
                          height: "140px",
                          background: "#f8f9fa",
                          marginBottom: "10px",
                          borderRadius: "6px",
                          overflow: "hidden",
                          position: "relative",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          border: "1px dashed #ced4da",
                        }}
                      >
                        {formDataState[item.key]?.file ? (
                          <div style={{ textAlign: "center", padding: "5px" }}>
                            <span
                              style={{ fontSize: "24px", display: "block" }}
                            >
                              📷
                            </span>
                            <span
                              style={{
                                fontSize: "12px",
                                color: "#198754",
                                fontWeight: "bold",
                              }}
                            >
                              Nueva imagen lista
                            </span>
                            <span
                              style={{
                                fontSize: "11px",
                                display: "block",
                                wordBreak: "break-all",
                                marginTop: "4px",
                                color: "#6c757d",
                              }}
                            >
                              {formDataState[item.key].file.name}
                            </span>
                          </div>
                        ) : (
                          <img
                            src={getImageSrc(currentData.image)}
                            alt="preview"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                        )}
                      </div>

                      <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => handleFileChange(e, item.key)}
                        style={{
                          fontSize: "12px",
                          width: "100%",
                          cursor: "pointer",
                          color: "#495057",
                        }}
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>

      {/* FOOTER - BOTONES */}
      <div
        style={{
          padding: "20px 30px",
          borderTop: "1px solid #e9ecef",
          backgroundColor: "#ffffff",
          display: "flex",
          justifyContent: "center", // Puedes cambiar a "flex-end" si los prefieres a la derecha
          gap: "15px",
        }}
      >
        <button
          type="button"
          onClick={() => {
            setOpenEditCategoriesForm(false);
            setHideContent(false);
          }}
          style={{
            padding: "10px 25px",
            fontSize: "14px",
            fontWeight: "bold",
            color: "#ffffff",
            backgroundColor: "#343a40", // Botón oscuro como en tu imagen
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
          }}
        >
          Cancelar
        </button>
        <button
          type="submit"
          disabled={loading}
          style={{
            padding: "10px 25px",
            fontSize: "14px",
            fontWeight: "bold",
            color: "#ffffff",
            backgroundColor: "#343a40", // Botón oscuro como en tu imagen
            border: "none",
            borderRadius: "6px",
            cursor: loading ? "not-allowed" : "pointer",
            opacity: loading ? 0.7 : 1,
          }}
        >
          {loading ? "Guardando..." : "Guardar"}
        </button>
      </div>
    </form>
  );
};

export default CategoriesEditForm;
